import { WebPlugin } from '@capacitor/core';
import type { PluginListenerHandle } from '@capacitor/core';

import type { JustWeiApkUpdaterPlugin, PermissionStatus, InstallStatus } from './definitions';

// Web平台模拟实现（实际环境中无法安装APK）
export class JustWeiApkUpdaterWeb extends WebPlugin implements JustWeiApkUpdaterPlugin {
  openMarket(options?: { packageName: string; }): Promise<void> {
    console.log('[JustWeiApkUpdater] Web平台不支持打开应用市场');
    console.log(options); // 为了消除警告
    throw this.unavailable('无法在Web平台打开应用市场');
  }
  // 模拟检查权限（Web上始终返回false）
  async checkPermissions(): Promise<PermissionStatus> {
    console.log('[JustWeiApkUpdater] Web平台不支持APK安装权限检查');
    return { canRequestPackageInstalls: "denied"};
  }

  // 模拟请求权限（Web上无法请求）
  async requestPermissions(): Promise<PermissionStatus> {
    console.log('[JustWeiApkUpdater] Web平台不支持请求APK安装权限');
    return { canRequestPackageInstalls:  "denied"};
  }

  // 模拟打开设置（Web上无法打开）
  async openInstallSetting(): Promise<void> {
    console.log('[JustWeiApkUpdater] Web平台不支持打开APK安装设置');
    throw this.unavailable('无法在Web平台打开安装设置');
  }

  // 模拟安装APK（Web上无法安装）
  async install(options: { apkPath: string }): Promise<InstallStatus> {
    console.log('[JustWeiApkUpdater] Web平台不支持APK安装');
    console.log(options); // 为了消除警告
    throw this.unavailable('无法在Web平台安装APK文件');
  }

  // 添加安装状态监听器（Web上返回空实现）
  addInstallListener(
    listenerFunc: (status: InstallStatus) => void,
  ): Promise<PluginListenerHandle> & PluginListenerHandle {
    console.log('[JustWeiApkUpdater] Web平台不支持监听安装状态变化');
    console.log(listenerFunc); // 为了消除警告

    // 创建监听器对象，同时满足Promise和PluginListenerHandle接口
    const listener: PluginListenerHandle & Promise<PluginListenerHandle> = Object.assign(
      // 实现PluginListenerHandle接口
      {
        remove: () => Promise.resolve(),
      },
      // 实现Promise<PluginListenerHandle>接口
      new Promise<PluginListenerHandle>((resolve) => {
        resolve({
          remove: () => Promise.resolve(),
        });
      }),
    );

    return listener;
  }

  // 移除所有监听器
  async removeAllListeners(): Promise<void> {
    console.log('[JustWeiApkUpdater] Web平台没有注册任何监听器');
  }

  /**
   * 打开指定的设置页面
   * @description Web平台不支持打开设置页面，因此直接抛出不可用异常
   * @param options 包含要打开的设置页面的操作名称 
   */
  openSetting(options: { action: string }): Promise<void> {
    console.log('[JustWeiApkUpdater] Web平台不支持打开设置页面');
    console.log(options); // 为了消除警告
    throw this.unavailable('无法在Web平台打开设置页面');
  }
}
